/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UsdtWethTricrypto2Lib,
  UsdtWethTricrypto2LibInterface,
} from "../UsdtWethTricrypto2Lib";

const _abi = [
  {
    inputs: [],
    name: "UNKNOWN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_INDEX",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH_INDEX",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60a7610039600b82828239805160001a60731461002c57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060455760003560e01c806173f414604a5780639199c722146063578063bccda83114606a575b600080fd5b6051600181565b60405190815260200160405180910390f35b6051600281565b605160008156fea2646970667358221220aa8b96d55fd8585cee217ee1646ad263136640dd3f593142f61178a92464076464736f6c634300080d0033";

type UsdtWethTricrypto2LibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UsdtWethTricrypto2LibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UsdtWethTricrypto2Lib__factory extends ContractFactory {
  constructor(...args: UsdtWethTricrypto2LibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UsdtWethTricrypto2Lib";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UsdtWethTricrypto2Lib> {
    return super.deploy(overrides || {}) as Promise<UsdtWethTricrypto2Lib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): UsdtWethTricrypto2Lib {
    return super.attach(address) as UsdtWethTricrypto2Lib;
  }
  connect(signer: Signer): UsdtWethTricrypto2Lib__factory {
    return super.connect(signer) as UsdtWethTricrypto2Lib__factory;
  }
  static readonly contractName: "UsdtWethTricrypto2Lib";
  public readonly contractName: "UsdtWethTricrypto2Lib";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UsdtWethTricrypto2LibInterface {
    return new utils.Interface(_abi) as UsdtWethTricrypto2LibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UsdtWethTricrypto2Lib {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UsdtWethTricrypto2Lib;
  }
}
